import { render } from "./dorNashrView.vue?vue&type=template&id=d20127c4&scoped=true"
import script from "./dorNashrView.vue?vue&type=script&lang=js"
export * from "./dorNashrView.vue?vue&type=script&lang=js"

import "./dorNashrView.vue?vue&type=style&index=0&id=d20127c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20127c4"]])

export default __exports__